import { AccordionDesignTokens } from '@primeuix/themes/types/accordion';

export default {
    root: {
        transitionDuration: '{transition.duration}',
    },
    panel: {
        borderWidth: '0 0 1.5px 0',
        borderColor: '{primary.300}',
    },
    header: {
        color: '{primary.400}',
        hoverColor: '{primary.300}',
        activeColor: '{primary.400}',
        activeHoverColor: '{primary.300}',
        padding: '0.75rem 1rem',
        fontWeight: '600',
        borderRadius: '0',
        borderWidth: '0',
        borderColor: '{content.border.color}',
        background: 'transparent',
        hoverBackground: 'transparent',
        activeBackground: 'transparent',
        activeHoverBackground: 'transparent',
        focusRing: {
            width: '{focus.ring.width}',
            style: '{focus.ring.style}',
            color: '{focus.ring.color}',
            offset: '-1px',
            shadow: '{focus.ring.shadow}',
        },
        toggleIcon: {
            color: '{primary.400}',
            hoverColor: '{primary.300}',
            activeColor: '{primary.400}',
            activeHoverColor: '{primary.300}',
        },
        first: {
            topBorderRadius: '{content.border.radius}',
            borderWidth: '0',
        },
        last: {
            bottomBorderRadius: '{content.border.radius}',
            activeBottomBorderRadius: '0',
        },
    },
    content: {
        borderWidth: '0',
        borderColor: '{content.border.color}',
        background: 'transparent',
        color: '{text.color}',
        padding: '0 0.5rem 0.5rem',
    },
} satisfies AccordionDesignTokens;
